
import Cookie from 'js-cookie'
export default {
  //获取服务端cookie
  getcookiesInServer:function (req) {
    let service_cookie = {};
    service_cookie=decodeURI(req.headers.cookie)
    let service_cookie2=service_cookie.indexOf('admin')
    let service_cookie3=service_cookie.indexOf('token')
    let obj ={group:service_cookie2,token:service_cookie3}
    return obj;
  },
  //获取客户端cookie
  getcookiesInClient:function (key) {
    return Cookie.get(key) ? JSON.parse(Cookie.get(key)) : ''
  }
}


// WEBPACK FOOTER //
// ./src/plugins/cookie.js